import { render, staticRenderFns } from "./shopBindOwner.vue?vue&type=template&id=f7c1d3ca&scoped=true"
import script from "./shopBindOwner.vue?vue&type=script&lang=js"
export * from "./shopBindOwner.vue?vue&type=script&lang=js"
import style0 from "./shopBindOwner.vue?vue&type=style&index=0&id=f7c1d3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c1d3ca",
  null
  
)

export default component.exports